<template>
  <div class="container">
    <div ref="bar" id="bar" style="height:300px;width:600px" v-show="false"></div>
    <div class="search">
      <p>录入测评答案，系统将自动生成对应的测评结果：</p>
    </div>

    <div class="mainContainer">
      <div class="head">

        <div class="title">一、选择要录入结果的量表：</div>
      </div>

      <div class="content">
        <div class="select">
          <div class="explain">
            所属量表分类：
          </div>
          <el-select
            v-model="typeValue"
            placeholder="量表分类"
            class="appraisalType"
            @change="selectType"
          >
            <el-option
              v-for="item in type"
              :key="item.value"
              :label="item.title"
              :value="item.catId"
            >
            </el-option>
          </el-select>
          <div
            class="explain"
            id="examinationPaper"
          >
            测评量表：
          </div>
          <el-select
            v-model="examinationPaperValue"
            placeholder="请选择"
            class="examinationPaper"
            @change="selectExaminationPaper"
          >
            <el-option
              v-for="item in examinationPaper"
              :key="item.value"
              :label="item.gaugeTitle"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <!-- <div class="sonExaminationPaperExplain">子试卷：</div>
          <el-select
            v-model="sonExaminationPaperValue"
            placeholder="请选择"
            class="sonExaminationPaper"
          >
            <el-option
              v-for="item in sonExaminationPaper"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </div>

        <div class="mainContent">
          <div class="sidebar">
            <h3>二、选择录入用户</h3>

            <div class="department">
              <h3>部门：</h3>
              <el-select
                v-model="departmentValue"
                placeholder="请选择"
                class="department"
                @change="selectClass"
              >
                <el-option
                  v-for="item in department"
                  :key="item.value"
                  :label="item.deptname"
                  :value="item.deptid"
                >
                </el-option>
              </el-select>
            </div>

            <div class="number">
              <h3>编号：</h3>
              <el-select
                v-model="numberValue"
                placeholder="请选择"
                class="number"
                @change="selectNumber"
              >
                <el-option
                  v-for="item in number"
                  :key="item.value"
                  :label="item.title"
                  :value="item.student_id"
                >
                </el-option>
              </el-select>
            </div>

            <div class="userName">
              <h3>用户姓名：</h3>

              <input
                type="text"
                v-model="userNameValue"
                disabled
              >

            </div>
            <div class="userSex">
              <h3>用户性别：</h3>

              <input
                type="text"
                v-model="userSexValue"
                disabled
              >

            </div>
          </div>

          <div class="contentAnswer">
            <h3 v-if="questions">三、录入答题卡</h3>
            <div
              class="answer"
              v-if="questions"
            >
              <div class="head">

                <div class="title">{{titleExaminationPaper}}</div>
                <div class="explain">共{{questions.length}}道题。</div>
              </div>

              <div
                class="answerItem"
                v-for="(item,index) in questions"
                :key="index"
              >
                <div class="explain">
                  第{{item.question_id}}题：{{item.option_answer}}

                </div>

                <div
                  class="answerSon"
                  v-for="(son,i) in item.answers"
                  :style="questionScore[0][index]==son.option_score?{background: '#ff500c'}:''"
                  :key="i"
                  @click="setAnswer(son,index,item.question_id)"
                >
                  <!-- {{son.option_score}} -->
                  {{ optionF[i] ? optionF[i] : (i + 1) }}
                </div>

              </div>

            </div>
          </div>
        </div>
        <div class="button">
          <button @click="submit">提交</button>
          <button @click="reset">重置</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
let bar;
export default {
  data() {
    return {
      // 测评类型
      typeValue: "",
      type: [],
      // 测评试卷：
      examinationPaper: [],
      examinationPaperValue: "",
      // 子试卷
      sonExaminationPaper: [],
      sonExaminationPaperValue: "",
      // 部门
      department: [],
      departmentValue: "",
      // 编号
      number: [],
      numberValue: "",

      // 用户性别
      userSex: [],
      userSexValue: "",
      // 用户姓名
      userName: [],
      userNameValue: "",
      // 试卷标题
      titleExaminationPaper: "",
      // 试卷题目数
      questions: "",
      // 答案
      questionScore: [[], []],
      // 用户id
      userId: "",

      optionF: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
    };
  },
  watch: {},
  methods: {
    // 提交答案
    async submit() {
      if (!this.questions) {
        this.$myMessage("请先选择测评量表");
        return
      }

      let questionScore = []
      for (let i = 0; i < this.questionScore[1].length; i++) {
        questionScore[i] = {
          question_id: this.questionScore[1][i],
          score: this.questionScore[0][i],
        }
      }

      const { data } = await this.$post("api/test/commitAnswerSheet", {
        testId: this.examinationPaperValue,
        testUid: this.userId,
        questionScore: questionScore,
      });
      if (data.code === "0") {
        let recordId = data.data.recordId
        let resultObj = JSON.parse(data.data.result)
        console.log(resultObj)

        let resultCategory = []
        for (let key in resultObj.resultCategory) {
          resultCategory.push(resultObj.resultCategory[key])
        }
        resultObj.resultCategory = resultCategory

        let result = resultObj.resultCategory.map((item) => {
          return [item.categoryName, item.categoryScores];
        });
        let base64 = this.handEcharts(result);
        this.$post("api/test/getRecordImage", {
          testType: 1,
          recordId: recordId,
          img: base64,
        });

        for (let i = 0; i < this.questionScore[1].length; i++) {
          this.questionScore[0][i] = undefined;
          this.questionScore[1][i] = undefined;
        }
        this.$forceUpdate();
      }
    },
    // 重置答案
    reset() {
      if (!this.questions) {
        return
      }

      for (let i = 0; i < this.questionScore[1].length; i++) {
        this.questionScore[0][i] = undefined;
        this.questionScore[1][i] = undefined;
      }
      this.$forceUpdate();
    },
    // 设置题目的答案
    setAnswer(son, i, question_id) {
      this.$set(this.questionScore[0], i, son.option_score);
      this.$set(this.questionScore[1], i, question_id);
    },
    // 根据试卷获取题目
    async selectExaminationPaper(item) {
      const { data } = await this.$post("api/test/getSomeTestQuestions", {
        testId: item,
      });
      console.log(data.data);
      this.titleExaminationPaper = data.data.list.info.title;
      this.questions = data.data.list.questions;
      this.questionScore[0].length = data.data.list.questions.length;
      this.questionScore[1].length = data.data.list.questions.length;
    },
    // 根据量表分类获取量表
    async selectType(item) {
      const { data } = await this.$post("api/test/getSomeCatGauge", {
        catId: item,
      });

      this.examinationPaper = data.data.list;
    },
    // 获取页面渲染的数据
    async getRenderData() {
      const { data } = await this.$post("api/msg/manageDept");

      const res = await this.$post("api/test/tableCat", { status: 1 });

      this.type = res.data.data.list;
      this.department = data.data.list;
    },
    // 根据部门获取下面的所有普通用户的编号
    async selectClass(item) {
      const { data } = await this.$post("api/msg/getStudentIdBySomeDept", {
        deptId: item,
      });
      this.number = data.data.list;
      this.numberValue = "";
      this.userNameValue = "";
      this.userSexValue = "";
    },
    // 根据编号获取用户信息
    async selectNumber(item) {
      const { data } = await this.$post("api/msg/getUserInfoBySID", {
        studentId: item,
      });

      this.userNameValue = data.data.list.nickname;
      this.userId = data.data.list.userid;
      this.userSexValue = data.data.list.sex;
    },

    handEcharts(record) {
      //销毁echarts实例
      if (bar) {
        bar.dispose();
      }
      bar = this.echarts.init(this.$refs.bar);
      let colors = ['#0AA7F4','#ED6942','#F29EC2','#36D5E5','#12B5B0','#F9B552','#e91e63','#f44336','#EEAD0E','#E066FF','#B3EE3A'];
      let option = {
        backgroundColor: "#fff",
        animation: false,
        grid: {
          top: "30",
          left: "40",
          right: "50",
          bottom: "60",
        },
        xAxis: {
          type: "category",
          //data: Array.from({ length: this.record.length }, (x, i) => x + i),
          axisLine: {
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 7], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: true, //---是否显示
            inside: true, //---是否朝内
            lengt: 2, //---长度
            lineStyle: {
              //color:'red',			//---默认取轴线的颜色
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 30,
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 10], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: false, //---是否显示
          },
          splitLine: {
            //---grid 区域中的分隔线
            show: true, //---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
            lineStyle: {
              color: "#404040",
              opacity: "0.2",
              width: 1,
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              //---图形形状
              borderRadius: [5, 5, 0, 0],
              color: function (params) {
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: 20, //---柱形宽度
            // barCategoryGap: "20%", //---柱形间距
            data: record,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      bar.setOption(option);
      //导出echarts
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };

      // window.addEventListener("resize", function () {
      //   bar.resize();
      // });

      return bar.getDataURL(opts); //拿到base64 地址
    },
  },
  created() {
    this.getRenderData();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.container {
  position: relative;

  .mainContainer {
    > .head {
      width: 1430px;
      height: 60px;
      opacity: 1;
      background: #fff;
      border-radius: 10px 10px 0px 0px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      > .title {
        margin-left: 70px;
      }
    }
    .content {
      width: 1430px;
      height: 710px;
      opacity: 1;
      background: #ffffff;
      border-radius: 0px 0px 10px 10px;
      box-sizing: border-box;
      padding: 0 35px 0;
      position: relative;
      padding: 8px 50px 0;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;

      .select {
        margin-left: 20px;
        display: flex;
        align-items: center;
        .explian {
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #222222;
        }
        .appraisalType {
          width: 200px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;
          margin-left: 20px;
          /deep/ .el-input--suffix {
            .el-input__inner {
              width: 200px;
              height: 40px;
              opacity: 1;
              background: #f0f0f0;
              border-radius: 4px;
              border: 0 none;
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: left;
              color: #333333;
            }
          }
        }

        #examinationPaper {
          margin: 0 20px 0 29px;
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #222222;
        }
        .examinationPaper {
          width: 300px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;
          /deep/ .el-input--suffix {
            .el-input__inner {
              width: 300px;
              height: 40px;
              opacity: 1;
              background: #f0f0f0;
              border-radius: 4px;
              border: 0 none;
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: left;
              color: #333333;
            }
          }
        }
        .sonExaminationPaperExplain {
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #222222;
          margin: 0 20px 0 30px;
        }
        .sonExaminationPaper {
          width: 300px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;
          /deep/ .el-input--suffix {
            .el-input__inner {
              width: 300px;
              height: 40px;
              opacity: 1;
              background: #f0f0f0;
              border-radius: 4px;
              border: 0 none;
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: left;
              color: #333333;
            }
          }
        }
      }
      .mainContent {
        margin-top: 30px;
        display: flex;
        .sidebar {
          width: 360px;
          height: 549px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 10px;
          padding: 19px 20px 0;
          box-sizing: border-box;
          h3 {
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #222222;
          }
          > .department,
          .number,
          .userName,
          .userSex {
            margin-top: 31px;
            h3 {
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: left;
              color: #333333;
              margin-bottom: 15px;
            }
            > .number,
            .department,
            .userName,
            .userSex {
              width: 320px;
              height: 40px;
              margin: 0;
            }
            input {
              width: 320px;
              height: 40px;
              border: 0 none;
              outline: none;
              padding-left: 15px;
              box-sizing: border-box;
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: left;
              color: #777777;
              background-color: #fff;
            }
          }
        }
        .contentAnswer {
          width: 950px;
          height: 549px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 10px;
          padding: 19px 50px 0;
          box-sizing: border-box;
          margin-left: 20px;
          h3 {
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #222222;
          }
          .answer {
            width: 850px;
            height: 414+80px;
            opacity: 1;
            background: #ffffff;
            overflow: hidden;
            border-radius: 10px 10px 0px 0px;
            overflow: auto;
            margin-top: 20px;
            &::-webkit-scrollbar {
              width: 10px;
              // background-color: skyblue;
            }
            &::-webkit-scrollbar-button {
              display: none;
            }
            &::-webkit-scrollbar-thumb {
              background-color: skyblue;
              border-radius: 5px;
            }
            .head {
              width: 100%;
              height: 80px;
              display: flex;
              flex-direction: column;
              align-items: center;
              > .title {
                font-size: 20px;
                height: 20px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #333333;
                margin-top: 15px;
                margin-bottom: 14px;
              }
              .explain {
                height: 16px;
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #999999;
              }
            }

            .answerItem {
              width: 100%;
              height: 40px;
              background-color: #fff;
              display: flex;
              align-items: center;
              border-top: 1px solid #f1f1f1;
              .explain {
                min-width: 90px;
                margin-left: 40px;
                margin-right: 10px;
                font-size: 14px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: left;
                color: #222222;
              }
              .answerSon {
                width: 20px;
                height: 20px;
                background: #f0f0f0;
                border-radius: 10px;
                margin-right: 27px;
                text-align: center;
                line-height: 20px;
              }
            }
            
          }
        }
        
      }
      .button {
        width: 100%;
        margin-top: 20px;
        text-align: center;
        button {
          width: 80px;
          height: 40px;
          opacity: 1;
          border-radius: 6px;
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
        }
        button:nth-child(1) {
          background: #3170ff;
          margin-right: 20px;
        }
        button:nth-child(2) {
          background: #f0f0f0;
        }
      }
    }
  }
}
</style>